// // src/activation/ActivationProvider.jsx
// import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
// import firebase from 'firebase/app';
// import 'firebase/firestore';

// /* -------------------------------------------------------------
//    Context state
// ------------------------------------------------------------- */
// const DEFAULT_STATE = {
//   active: false,
//   loading: true,
//   model: 'unknown',          // 'new' | 'legacy' | 'unknown'
//   legacyActive: null,
//   legacySlots: 0,
//   legacyStudents: 0,
//   newActive: null,
//   newRequired: 0,
//   newPaid: 0,
//   studentCount: 0,
//   calculatedAtMs: 0,
//   fromCache: false,
// };

// const ActivationCtx = createContext(DEFAULT_STATE);

// /* -------------------------------------------------------------
//    Helpers
// ------------------------------------------------------------- */
// const ts = () => new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm
// const nowMs = () => Date.now();

// const num = (x) => {
//   const n = Number(x);
//   return Number.isFinite(n) ? n : 0;
// };
// const toBoolLoose = (x) => {
//   if (typeof x === 'boolean') return x;
//   const s = String(x || '').trim().toLowerCase();
//   return ['true', '1', 'yes', 'y'].includes(s);
// };
// const firstPositive = (...cands) => {
//   for (const c of cands) {
//     const n = num(c);
//     if (n > 0) return n;
//   }
//   return 0;
// };

// /** Firestore doc IDs must not contain '/', and it's safer to normalize spaces & special chars. */
// const sanitizeId = (s) =>
//   String(s || '')
//     .replace(/\//g, '_')        // critical: no slashes
//     .replace(/[.#\[\]]/g, '_')  // other risky chars
//     .replace(/\s+/g, '_')       // spaces → underscore
//     .replace(/_+/g, '_')        // collapse multiple _
//     .trim();

// /** Canonical term id */
// const makeTermId = (schoolId, session, term) =>
//   sanitizeId(`${String(schoolId)}_${String(session)}_${String(term)}`);

// /** Read money in UNITS (₦). Prefer unit keys; fall back to *_kobo /100. */
// function readMoneyUnits(d, unitKeys = [], koboKeys = []) {
//   const u = firstPositive(...unitKeys.map((k) => d?.[k]));
//   if (u > 0) return u;
//   const k = firstPositive(...koboKeys.map((k) => d?.[k]));
//   return k > 0 ? Math.round(k / 100) : 0;
// }

// /** NEW model (STRICT): if required is known/derivable, only paid>=required decides. */
// function computeActiveFromNewVerbose(d) {
//   // explicit required (₦)
//   const reqExplicit = readMoneyUnits(
//     d,
//     ['required_amount', 'required', 'requiredTotal', 'amount_due', 'due', 'expected', 'total_due'],
//     ['required_amount_kobo', 'required_kobo', 'required_total_kobo', 'requiredTotalKobo', 'amount_due_kobo', 'due_kobo', 'expected_kobo', 'total_due_kobo']
//   );

//   // compute fallback from students * charge
//   let reqUnits = reqExplicit;
//   if (reqUnits <= 0) {
//     const computed = Number(d?.student_count || d?.students || 0) * Number(d?.charge_per_student || d?.per_student || 0);
//     if (computed > 0) reqUnits = computed;
//   }

//   // total deposits (₦)
//   const depUnits = readMoneyUnits(
//     d,
//     ['deposits_total', 'deposits', 'paid_total', 'payments_total', 'receipts_total'],
//     ['deposits_total_kobo', 'deposits_kobo', 'paid_total_kobo', 'payments_total_kobo', 'receipts_total_kobo']
//   );

//   // hints (ignored in UI; kept for parity)
//   const hints = {};
//   if (Object.prototype.hasOwnProperty.call(d || {}, 'is_paid') && d.is_paid !== undefined) hints.is_paid = d.is_paid;
//   if (typeof d?.status === 'string') hints.status = d.status;

//   if (reqUnits > 0) {
//     return {
//       active: depUnits >= reqUnits,
//       decidedBy: 'deposit>=required',
//       reqUnits,
//       depUnits,
//       hints,
//     };
//   }

//   // Only if no required amount at all, allow flags
//   if (Object.prototype.hasOwnProperty.call(d || {}, 'is_paid') && d.is_paid !== undefined) {
//     const paid = toBoolLoose(d.is_paid);
//     return { active: paid, decidedBy: 'is_paid(no-required)', reqUnits, depUnits, hints };
//   }
//   if (typeof d?.status === 'string') {
//     const s = String(d.status || '').toLowerCase();
//     if (['paid', 'active', 'settled'].includes(s)) return { active: true, decidedBy: `status:${s}(no-required)`, reqUnits, depUnits, hints };
//     if (['unpaid', 'inactive', 'owing', 'due'].includes(s)) return { active: false, decidedBy: `status:${s}(no-required)`, reqUnits, depUnits, hints };
//   }

//   return { active: false, decidedBy: 'no-required', reqUnits, depUnits, hints };
// }

// /** LEGACY model: plan + slot vs active students */
// function computeActiveFromLegacyVerbose(sub, studentCount) {
//   const plan = String(sub?.plan || '').trim().toLowerCase();
//   const slots = num(sub?.slot ?? sub?.slots);
//   const total = num(studentCount);

//   if (plan === 'trial') return { active: true, decidedBy: 'trial', plan, slots, total };
//   if (total <= 0) return { active: false, decidedBy: 'no-students', plan, slots, total };
//   return { active: slots >= total, decidedBy: 'slots>=total', plan, slots, total };
// }

// /** Active student count (exclude 'graduated'), robust + lean with select('class') */
// async function getActiveStudentsCountBreakdown(db, schoolId) {
//   try {
//     const snap = await db
//       .collection('students')
//       .where('school', '==', schoolId)
//       .select('class')
//       .get({ source: 'server' }); // ignore cache

//     let total = 0;
//     let grads = 0;
//     for (const d of snap.docs) {
//       total += 1;
//       const cls = String(d.get('class') || '').toLowerCase();
//       if (cls === 'graduated') grads += 1;
//     }
//     const active = Math.max(0, total - grads);
//     return { active, total, grads, variants: ['graduated'] };
//   } catch (e) {
//     // Fallback w/o .select (older SDKs)
//     try {
//       const snap = await db
//         .collection('students')
//         .where('school', '==', schoolId)
//         .get({ source: 'server' });

//       let total = 0;
//       let grads = 0;
//       for (const d of snap.docs) {
//         total += 1;
//         const cls = String(d.get('class') || '').toLowerCase();
//         if (cls === 'graduated') grads += 1;
//       }
//       const active = Math.max(0, total - grads);
//       return { active, total, grads, variants: ['graduated'] };
//     } catch (e2) {
//       console.error('[activation] student count failed:', e2?.message || e2);
//       return { active: 0, total: 0, grads: 0, variants: ['graduated'] };
//     }
//   }
// }

// /** Try common legacy doc-id variants — ALWAYS sanitize ids before doc(). */
// async function findLegacySubscriptionDoc(db, schoolId, session, term) {
//   const S = String(session);
//   const T = String(term);

//   const sessionCands = Array.from(
//     new Set([
//       S,
//       S.replace(/\//g, '_'),
//       S.replace('/', '_'),
//       S.replace(/[-/]/g, '_'),
//       S.trim().replace(/\s+/g, '_'),
//     ])
//   );
//   const termCands = Array.from(
//     new Set([T, T.trim().replace(/\s+/g, '_'), T.replace(' ', '_'), T.trim()])
//   );

//   for (const sc of sessionCands) {
//     for (const tc of termCands) {
//       const rawId = `${schoolId}_${sc}_${tc}`;
//       const safeId = sanitizeId(rawId);
//       try {
//         const snap = await db.collection('subscription').doc(safeId).get({ source: 'server' });
//         if (snap.exists) return snap;
//       } catch (err) {
//         // If any candidate still trips Firestore (shouldn't, we sanitize), skip to next
//         console.warn('[activation] legacy id candidate failed:', rawId, err?.message || err);
//       }
//     }
//   }
//   return null;
// }

// /** Client-side recompute (server parity) */
// async function recomputeActivationClient(db, schoolId, session, term, termIdRaw) {
//   const termId = sanitizeId(termIdRaw);
//   const out = {
//     calculatedAtMs: nowMs(),
//     active: false,
//     model: 'unknown',
//     legacy_active: null,
//     legacy_slots: 0,
//     legacy_students: 0,
//     new_active: null,
//     new_required: 0,
//     new_paid: 0,
//     studentCount: 0,
//   };

//   try {
//     // Pull NEW + LEGACY docs (server only)
//     const [legacySnapPrimary, newSnap] = await Promise.all([
//       db.collection('subscription').doc(termId).get({ source: 'server' }),
//       db.collection('billing_terms').doc(termId).get({ source: 'server' }),
//     ]);

//     // NEW verdict
//     if (newSnap.exists) {
//       const nd = newSnap.data() || {};
//       const nv = computeActiveFromNewVerbose(nd);
//       out.new_active = !!nv.active;
//       out.new_required = num(nv.reqUnits);
//       out.new_paid = num(nv.depUnits);
//     } else {
//       out.new_active = false;
//       out.new_required = 0;
//       out.new_paid = 0;
//     }

//     // LEGACY lookup (primary or variants)
//     let legacySnap = legacySnapPrimary;
//     if (!legacySnapPrimary.exists) {
//       const found = await findLegacySubscriptionDoc(db, schoolId, session, term);
//       if (found && found.exists) legacySnap = found;
//     }

//     if (legacySnap && legacySnap.exists) {
//       const sc = await getActiveStudentsCountBreakdown(db, schoolId);
//       const studentCount = sc.active;
//       out.studentCount = studentCount;

//       const sub = legacySnap.data() || {};
//       const lv = computeActiveFromLegacyVerbose(sub, studentCount);

//       out.legacy_active = !!lv.active;
//       out.legacy_slots = num(lv.slots);
//       out.legacy_students = num(lv.total);

//       if (lv.active) {
//         out.active = true;
//         out.model = 'legacy';
//       } else {
//         if (newSnap.exists && out.new_active) {
//           out.active = true;
//           out.model = 'new';
//         } else {
//           out.active = false;
//           out.model = newSnap.exists ? 'new' : 'legacy';
//         }
//       }
//     } else if (newSnap.exists) {
//       // No legacy → NEW strict
//       out.active = !!out.new_active;
//       out.model = 'new';
//     } else {
//       out.active = false;
//       out.model = 'unknown';
//     }
//   } catch (e) {
//     console.error('[activation] recomputeActivationClient error:', e?.message || e);
//     out.active = false;
//     out.model = 'unknown';
//   }

//   return out;
// }

// /* -------------------------------------------------------------
//    Provider (client-only, server-authoritative reads)
// ------------------------------------------------------------- */
// export function ActivationProvider({ schoolId, session, term, children }) {
//   const [state, setState] = useState(DEFAULT_STATE);
//   const mountedRef = useRef(false);
//   const lastCalcMsRef = useRef(0);
//   const unsubRefs = useRef([]);

//   const setSafe = (next, source) => {
//     if (!mountedRef.current) return;
//     setState((prev) => {
//       const changed =
//         prev.active !== next.active ||
//         prev.loading !== next.loading ||
//         prev.model !== next.model ||
//         prev.calculatedAtMs !== next.calculatedAtMs;
//       if (changed && typeof window !== 'undefined') {
//         window.__activationDebug = {
//           at: ts(),
//           source,
//           next,
//           schoolId,
//           session,
//           term,
//           lastCalcMs: lastCalcMsRef.current,
//         };
//       }
//       return changed ? next : prev;
//     });
//   };

//   const hardRecompute = async () => {
//     if (!schoolId || !session || !term) {
//       // Stay in loading=true until keys arrive
//       setSafe({ ...DEFAULT_STATE, loading: true }, 'missing-keys');
//       return;
//     }
//     const db = firebase.firestore();
//     const termId = makeTermId(schoolId, session, term); // sanitized inside

//     // Compute from server docs only (ignore cache)
//     const out = await recomputeActivationClient(db, schoolId, session, term, termId);
//     const incomingMs = out.calculatedAtMs || nowMs();
//     const slackMs = 1000;
//     if (incomingMs + slackMs < lastCalcMsRef.current) return; // stale

//     lastCalcMsRef.current = Math.max(lastCalcMsRef.current, incomingMs);

//     setSafe(
//       {
//         active: !!out.active,
//         loading: false,
//         model: out.model || 'unknown',
//         legacyActive: out.legacy_active ?? null,
//         legacySlots: Number(out.legacy_slots || 0),
//         legacyStudents: Number(out.legacy_students || 0),
//         newActive: out.new_active ?? null,
//         newRequired: Number(out.new_required || 0),
//         newPaid: Number(out.new_paid || 0),
//         studentCount: Number(out.studentCount || 0),
//         calculatedAtMs: incomingMs,
//         fromCache: false,
//       },
//       'recompute'
//     );
//   };

//   useEffect(() => {
//     mountedRef.current = true;
//     return () => {
//       mountedRef.current = false;
//       // cleanup listeners on unmount
//       for (const u of unsubRefs.current) {
//         try { u && u(); } catch {}
//       }
//       unsubRefs.current = [];
//     };
//   }, []);

//   useEffect(() => {
//     // Cleanup previous listeners whenever keys change
//     for (const u of unsubRefs.current) {
//       try { u && u(); } catch {}
//     }
//     unsubRefs.current = [];
//     lastCalcMsRef.current = 0;

//     // Reset UI while recomputing
//     setSafe({ ...DEFAULT_STATE, loading: true }, 'props-change');

//     // Immediate recompute from server documents
//     hardRecompute();

//     if (!schoolId || !session || !term) return () => {};

//     const db = firebase.firestore();
//     const termId = makeTermId(schoolId, session, term); // sanitized

//     // Live listeners on billing_terms + subscription — ignore cache; on server change, recompute
//     const btUnsub = db
//       .collection('billing_terms')
//       .doc(termId)
//       .onSnapshot({ includeMetadataChanges: true }, (snap) => {
//         if (!mountedRef.current) return;
//         if (snap.metadata?.fromCache) return; // ignore cache
//         hardRecompute();
//       });
//     unsubRefs.current.push(btUnsub);

//     const subUnsub = db
//       .collection('subscription')
//       .doc(termId)
//       .onSnapshot({ includeMetadataChanges: true }, (snap) => {
//         if (!mountedRef.current) return;
//         if (snap.metadata?.fromCache) return; // ignore cache
//         hardRecompute();
//       });
//     unsubRefs.current.push(subUnsub);

//     return () => {
//       for (const u of unsubRefs.current) {
//         try { u && u(); } catch {}
//       }
//       unsubRefs.current = [];
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [schoolId, session, term]);

//   return (
//     <ActivationCtx.Provider value={state}>
//       {children}
//     </ActivationCtx.Provider>
//   );
// }

// /* -------------------------------------------------------------
//    Hook
// ------------------------------------------------------------- */
// export function useActivation() {
//   return useContext(ActivationCtx);
// }

// src/activation/ActivationProvider.jsx
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { reactLocalStorage } from 'reactjs-localstorage';
import { computeLegacySubscriptionStatus } from './legacySubscriptionStatus';

/* -------------------------------------------------------------
   Context state
------------------------------------------------------------- */
const DEFAULT_STATE = {
  active: false,
  loading: true,
  model: 'unknown',          // 'legacy' | 'unknown'
  legacyActive: null,
  legacySlots: 0,
  legacyStudents: 0,

  // NEW (disabled for now)
  newActive: null,
  newRequired: 0,
  newPaid: 0,

  studentCount: 0,
  calculatedAtMs: 0,
  fromCache: false,
};

const ActivationCtx = createContext(DEFAULT_STATE);

/* -------------------------------------------------------------
   Helpers
------------------------------------------------------------- */
const ts = () => new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm
const nowMs = () => Date.now();

const num = (x) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : 0;
};

const isTruthy = (v) => {
  if (v === true || v === 1) return true;
  const s = String(v ?? '').trim().toLowerCase();
  if (!s) return false;
  return ['true', '1', 'yes', 'on'].includes(s);
};

const isPlatformRole = (role) => {
  const s = String(role || '').trim().toLowerCase();
  return s.includes('developer') || s.includes('platform') || s.includes('super');
};

const isDeveloperBypassSession = () => {
  const bypass = isTruthy(reactLocalStorage.get('developer-subscription-bypass'));
  if (!bypass) return false;
  const role = reactLocalStorage.get('role');
  const platformFlag = reactLocalStorage.get('platform-admin');
  return isTruthy(platformFlag) || isPlatformRole(role);
};

const isPlatformConsoleSession = () => {
  const platformConsoleFlag = reactLocalStorage.get('platform-console');
  if (!isTruthy(platformConsoleFlag)) return false;
  const role = reactLocalStorage.get('role');
  const platformFlag = reactLocalStorage.get('platform-admin');
  return isTruthy(platformFlag) || isPlatformRole(role);
};

const sanitizeId = (s) =>
  String(s || '')
    .replace(/\//g, '_')
    .replace(/[.#\[\]]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .trim();

/** Canonical term id */
const makeTermId = (schoolId, session, term) =>
  sanitizeId(`${String(schoolId)}_${String(session)}_${String(term)}`);

/** LEGACY model: plan + slot vs active students */
function computeActiveFromLegacyVerbose(sub, studentCount) {
  return computeLegacySubscriptionStatus(sub, studentCount);
}

/** Active student count (exclude 'graduated'), robust + lean with select('class') */
async function getActiveStudentsCountBreakdown(db, schoolId) {
  try {
    const snap = await db
      .collection('students')
      .where('school', '==', schoolId)
      .select('class')
      .get({ source: 'server' });

    let total = 0;
    let grads = 0;
    for (const d of snap.docs) {
      total += 1;
      const cls = String(d.get('class') || '').toLowerCase();
      if (cls === 'graduated') grads += 1;
    }
    const active = Math.max(0, total - grads);
    return { active, total, grads, variants: ['graduated'] };
  } catch (e) {
    // Fallback w/o .select (older SDKs)
    try {
      const snap = await db
        .collection('students')
        .where('school', '==', schoolId)
        .get({ source: 'server' });

      let total = 0;
      let grads = 0;
      for (const d of snap.docs) {
        total += 1;
        const cls = String(d.get('class') || '').toLowerCase();
        if (cls === 'graduated') grads += 1;
      }
      const active = Math.max(0, total - grads);
      return { active, total, grads, variants: ['graduated'] };
    } catch (e2) {
      console.error('[activation] student count failed:', e2?.message || e2);
      return { active: 0, total: 0, grads: 0, variants: ['graduated'] };
    }
  }
}

/** Try common legacy doc-id variants — ALWAYS sanitize ids before doc(). */
async function findLegacySubscriptionDoc(db, schoolId, session, term) {
  const S = String(session);
  const T = String(term);

  const sessionCands = Array.from(
    new Set([
      S,
      S.replace(/\//g, '_'),
      S.replace('/', '_'),
      S.replace(/[-/]/g, '_'),
      S.trim().replace(/\s+/g, '_'),
    ])
  );
  const termCands = Array.from(
    new Set([T, T.trim().replace(/\s+/g, '_'), T.replace(' ', '_'), T.trim()])
  );

  for (const sc of sessionCands) {
    for (const tc of termCands) {
      const rawId = `${schoolId}_${sc}_${tc}`;
      const safeId = sanitizeId(rawId);
      try {
        const snap = await db.collection('subscription').doc(safeId).get({ source: 'server' });
        if (snap.exists) return snap;
      } catch (err) {
        console.warn('[activation] legacy id candidate failed:', rawId, err?.message || err);
      }
    }
  }
  return null;
}

/** Client-side recompute (LEGACY ONLY) */
async function recomputeActivationClient(db, schoolId, session, term, termIdRaw) {
  const termId = sanitizeId(termIdRaw);

  const out = {
    calculatedAtMs: nowMs(),
    active: false,
    model: 'unknown',

    legacy_active: null,
    legacy_slots: 0,
    legacy_students: 0,

    // NEW disabled
    new_active: null,
    new_required: 0,
    new_paid: 0,

    studentCount: 0,
  };

  try {
    // -----------------------------
    // NEW billing_terms DISABLED
    // -----------------------------
    // const newSnap = await db.collection('billing_terms').doc(termId).get({ source: 'server' });
    // if (newSnap.exists) {
    //   const nd = newSnap.data() || {};
    //   const nv = computeActiveFromNewVerbose(nd);
    //   out.new_active = !!nv.active;
    //   out.new_required = num(nv.reqUnits);
    //   out.new_paid = num(nv.depUnits);
    // }

    // -----------------------------
    // LEGACY ACTIVE ONLY
    // -----------------------------
    const legacySnapPrimary = await db.collection('subscription').doc(termId).get({ source: 'server' });

    let legacySnap = legacySnapPrimary;
    if (!legacySnapPrimary.exists) {
      const found = await findLegacySubscriptionDoc(db, schoolId, session, term);
      if (found && found.exists) legacySnap = found;
    }

    if (legacySnap && legacySnap.exists) {
      const sc = await getActiveStudentsCountBreakdown(db, schoolId);
      const studentCount = sc.active;
      out.studentCount = studentCount;

      const sub = legacySnap.data() || {};
      const lv = computeActiveFromLegacyVerbose(sub, studentCount);

      out.legacy_active = !!lv.active;
      out.legacy_slots = num(lv.slots);
      out.legacy_students = num(lv.total);

      out.active = !!lv.active;
      out.model = 'legacy';
    } else {
      out.active = false;
      out.model = 'unknown';
    }
  } catch (e) {
    console.error('[activation] recomputeActivationClient error:', e?.message || e);
    out.active = false;
    out.model = 'unknown';
  }

  return out;
}

/* -------------------------------------------------------------
   Provider (client-only, server-authoritative reads)
------------------------------------------------------------- */
export function ActivationProvider({
  schoolId,
  session,
  term,
  developerBypassToken,
  children,
}) {
  const [state, setState] = useState(DEFAULT_STATE);
  const mountedRef = useRef(false);
  const lastCalcMsRef = useRef(0);
  const unsubRefs = useRef([]);

  const setSafe = (next, source) => {
    if (!mountedRef.current) return;
    setState((prev) => {
      const changed =
        prev.active !== next.active ||
        prev.loading !== next.loading ||
        prev.model !== next.model ||
        prev.calculatedAtMs !== next.calculatedAtMs;

      if (changed && typeof window !== 'undefined') {
        window.__activationDebug = {
          at: ts(),
          source,
          next,
          schoolId,
          session,
          term,
          lastCalcMs: lastCalcMsRef.current,
        };
      }
      return changed ? next : prev;
    });
  };

  const hardRecompute = async () => {
    if (isDeveloperBypassSession() || isPlatformConsoleSession()) {
      const atMs = nowMs();
      lastCalcMsRef.current = Math.max(lastCalcMsRef.current, atMs);
      setSafe(
        {
          ...DEFAULT_STATE,
          active: true,
          loading: false,
          model: isPlatformConsoleSession() ? 'platform-console' : 'developer-bypass',
          calculatedAtMs: atMs,
          fromCache: false,
        },
        isPlatformConsoleSession() ? 'platform-console' : 'developer-bypass'
      );
      return;
    }

    if (!schoolId || !session || !term) {
      setSafe({ ...DEFAULT_STATE, loading: true }, 'missing-keys');
      return;
    }

    const db = firebase.firestore();
    const termId = makeTermId(schoolId, session, term);

    const out = await recomputeActivationClient(db, schoolId, session, term, termId);
    const incomingMs = out.calculatedAtMs || nowMs();
    const slackMs = 1000;
    if (incomingMs + slackMs < lastCalcMsRef.current) return;

    lastCalcMsRef.current = Math.max(lastCalcMsRef.current, incomingMs);

    setSafe(
      {
        active: !!out.active,
        loading: false,
        model: out.model || 'unknown',
        legacyActive: out.legacy_active ?? null,
        legacySlots: Number(out.legacy_slots || 0),
        legacyStudents: Number(out.legacy_students || 0),

        // NEW disabled → keep defaults
        newActive: null,
        newRequired: 0,
        newPaid: 0,

        studentCount: Number(out.studentCount || 0),
        calculatedAtMs: incomingMs,
        fromCache: false,
      },
      'recompute'
    );
  };

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      for (const u of unsubRefs.current) {
        try { u && u(); } catch {}
      }
      unsubRefs.current = [];
    };
  }, []);

  useEffect(() => {
    for (const u of unsubRefs.current) {
      try { u && u(); } catch {}
    }
    unsubRefs.current = [];
    lastCalcMsRef.current = 0;

    setSafe({ ...DEFAULT_STATE, loading: true }, 'props-change');

    hardRecompute();

    if (!schoolId || !session || !term) return () => {};

    const db = firebase.firestore();
    const termId = makeTermId(schoolId, session, term);

    // -----------------------------
    // NEW billing_terms listener DISABLED
    // -----------------------------
    // const btUnsub = db
    //   .collection('billing_terms')
    //   .doc(termId)
    //   .onSnapshot({ includeMetadataChanges: true }, (snap) => {
    //     if (!mountedRef.current) return;
    //     if (snap.metadata?.fromCache) return;
    //     hardRecompute();
    //   });
    // unsubRefs.current.push(btUnsub);

    // LEGACY subscription listener ACTIVE
    const subUnsub = db
      .collection('subscription')
      .doc(termId)
      .onSnapshot({ includeMetadataChanges: true }, (snap) => {
        if (!mountedRef.current) return;
        if (snap.metadata?.fromCache) return;
        hardRecompute();
      });
    unsubRefs.current.push(subUnsub);

    return () => {
      for (const u of unsubRefs.current) {
        try { u && u(); } catch {}
      }
      unsubRefs.current = [];
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId, session, term, developerBypassToken]);

  return (
    <ActivationCtx.Provider value={state}>
      {children}
    </ActivationCtx.Provider>
  );
}

/* -------------------------------------------------------------
   Hook
------------------------------------------------------------- */
export function useActivation() {
  return useContext(ActivationCtx);
}
